'use strict';

import App from './App';
import router from './router';
import {initFilters} from './filters';
import {initDirectives} from './directives';
import moment from 'moment';

moment.locale('fr');
initFilters();
initDirectives();
router.start(App, 'div');



// WEBPACK FOOTER //
// ./src/main.js